import React from "react";
import "../style/footer.css";
import InstaIcon from "../images/instagram.svg";
import LinkedInIcon from "../images/linkedin.svg";
import GitHubIcon from "../images/github.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="social-icons">
          <a href="https://www.linkedin.com/in/nirmal-chaudhary-9a36ab230/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="icon-link">
            <img src={LinkedInIcon} alt="LinkedIn" className="icon-svg" />
          </a>
          <a href="https://github.com/Nirmalchaudhary" target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="icon-link">
            <img src={GitHubIcon} alt="GitHub" className="icon-svg" />
          </a>
          <a href="https://www.instagram.com/mr_chaudhary107?igsh=MXVxZ2gzMXBxMWZ4cQ==" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="icon-link">
            <img src={InstaIcon} alt="Twitter" className="icon-svg" />
          </a>
        </div>
        <div className="footer-text">
          <p>Made by <span>Nirmal Chaudhary 🧑‍💻</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
